import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/acl",
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "About" */ "./views/About.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/acl",
      name: "acl",
      component: () => import(/* webpackChunkName: "Acl" */ "./views/Acl.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/blankpresentation",
      name: "blankpresentation",
      component: () =>
        import(/* webpackChunkName: "BlankPresentation" */ "./views/BlankPresentation.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/issues",
      name: "issues",
      component: () =>
        import(/* webpackChunkName: "Issues" */ "./views/Issues.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/dashboards",
      name: "dashboards",
      component: () =>
        import(/* webpackChunkName: "Plugins" */ "./views/Dashboards.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/userStatics",
      name: "userStatics",
      component: () =>
        import(/* webpackChunkName: "Plugins" */ "./views/UserStatics.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/userAnalytics",
      name: "userAnalytics",
      component: () =>
        import(/* webpackChunkName: "UserAnalytics" */ "./views/UserAnalytics.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/logs",
      name: "logs",
      component: () =>
        import(/* webpackChunkName: "Logs" */ "./views/Logs.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/emails",
      name: "emails",
      component: () =>
        import(/* webpackChunkName: "Logs" */ "./views/Emails.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/plugins",
      name: "plugins",
      component: () =>
        import(/* webpackChunkName: "Plugins" */ "./views/Plugins.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/spellingdictionaries",
      name: "spellingdictionaries",
      component: () =>
        import(/* webpackChunkName: "SpellingDictionaries" */ "./views/SpellingDictionaries.vue"),
      meta: {
        requireAuth: true,
      },
    },
  ],
});
